import { ChevronRight, Mail, Shield } from 'lucide-react';
import SettingsGroup from './SettingsGroup';
import SettingsRow from './SettingsRow';

type HelpSupportCardProps = {
  onOpenPrivacyPolicy: () => void;
};

const HelpSupportCard = ({ onOpenPrivacyPolicy }: HelpSupportCardProps) => (
  <SettingsGroup title='Help & support'>
    <a href='mailto:support@tenantpay.com' className='block'>
      <SettingsRow
        icon={<Mail size={14} />}
        label='Contact support'
        value='support@tenantpay.com'
        action={<ChevronRight size={16} className='text-[#9AA0AE]' />}
      />
    </a>
    <div onClick={onOpenPrivacyPolicy} className='cursor-pointer'>
      <SettingsRow
        icon={<Shield size={14} />}
        label='Privacy policy'
        value='Read terms and privacy details'
        action={<ChevronRight size={16} className='text-[#9AA0AE]' />}
      />
    </div>
  </SettingsGroup>
);

export default HelpSupportCard;
